import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, RouteIcon, ShieldIcon, GlobeIcon } from 'lucide-react';
export function Advantages() {
  const advantages = [{
    icon: RouteIcon,
    title: 'Acceso directo desde Ruta al Atlántico',
    description: 'Ubicación estratégica con conexión inmediata a la principal vía de transporte'
  }, {
    icon: MapPinIcon,
    title: 'Conexión a Ciudad de Guatemala',
    description: 'Punto intermedio ideal para operaciones hacia la capital'
  }, {
    icon: GlobeIcon,
    title: 'Proyección regional',
    description: 'Acceso facilitado hacia México, Belice, Honduras y El Salvador'
  }, {
    icon: ShieldIcon,
    title: 'Complejo cerrado con seguridad',
    description: 'Muro perimetral y monitoreo con cámaras 24/7'
  }];
  return <section className="bg-gradient-to-b from-zinc-900 via-black to-zinc-900 py-20 px-4 relative overflow-hidden scroll-mt-20" data-id="element-1">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-5" data-id="element-2">
        <div className="absolute inset-0" style={{
        backgroundImage: `
            linear-gradient(rgba(252, 211, 77, 0.2) 1px, transparent 1px),
            linear-gradient(90deg, rgba(252, 211, 77, 0.2) 1px, transparent 1px)
          `,
        backgroundSize: '100px 100px'
      }} data-id="element-3" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-5">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-6">
            Ventajas <span className="text-yellow-400" data-id="element-7">Estratégicas</span>
          </h2>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: 96
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent mx-auto mb-8" data-id="element-8" />
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-9">
            Río Hondo, Zacapa - El punto logístico que conecta Centroamérica
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-10">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative group" data-id="element-11">
            <div className="aspect-video bg-zinc-800 rounded-xl overflow-hidden border border-zinc-700 group-hover:border-yellow-400 transition-all duration-500 relative" data-id="element-12">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/0 via-yellow-400/0 to-yellow-400/0 group-hover:from-yellow-400/10 group-hover:to-yellow-400/5 transition-all duration-500" data-id="element-13" />

              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6aEUqEkxq9Jw3BBYs7FCvk/BODENOR.00_00_32_21.Imagen_fija004.jpg" alt="Mapa de ubicación estratégica - Bodenor conecta Ciudad de Guatemala con México, Belice, Honduras y El Salvador" className="w-full h-full object-cover" data-id="element-14" />
            </div>

            {/* Corner accents */}
            <div className="absolute -top-2 -left-2 w-8 h-8 border-t-2 border-l-2 border-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-15" />
            <div className="absolute -bottom-2 -right-2 w-8 h-8 border-b-2 border-r-2 border-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-16" />
          </motion.div>

          <div className="space-y-6" data-id="element-17">
            {advantages.map((advantage, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="flex gap-4 items-start group" data-id="element-18">
                <motion.div whileHover={{
              scale: 1.1,
              rotate: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} className="bg-gradient-to-br from-yellow-400 to-yellow-500 w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 shadow-[0_0_20px_rgba(252,211,77,0.3)] group-hover:shadow-[0_0_30px_rgba(252,211,77,0.5)] transition-all duration-300" data-id="element-19">
                  <advantage.icon size={24} className="text-black" data-id="element-20" />
                </motion.div>
                <div data-id="element-21">
                  <h3 className="text-xl font-bold text-white mb-2 group-hover:text-yellow-400 transition-colors duration-300" data-id="element-22">
                    {advantage.title}
                  </h3>
                  <p className="text-gray-300" data-id="element-23">{advantage.description}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}